module.exports = __webpack_public_path__ + "static/media/popup_open.53c1e3a5.mp3";